import { graphql } from "react-relay";
import { TeamHealthDashboard } from "./TeamHealthDashboard";
import { TeammateAnalyticsCard } from "@components/teammate-analytics-card";
import { TeamPickerWithActions } from "@components/team-picker";

export const fragments = {
  org: graphql`
    fragment TeamHealthDashboard_org on Org
    @argumentDefinitions(
      timeZone: { type: "String!" }
      rangeMin: { type: "DayTimeSlotInput!" }
      rangeMax: { type: "DayTimeSlotInput!" }
      teamId: { type: "String!" }
      hasTeams: { type: "Boolean!" }
    ) {
      ...TeammateAnalyticsCard_org
      id
      experiments
      primaryTeam {
        __typename
        ... on Team {
          teamId
          teamName
        }
        ... on GraphEntityError {
          statusCode
          message
        }
      }
      userTeams {
        __typename
        ... on TeamList {
          ...TeamPickerWithActions_userTeams
          list {
            teamId
          }
        }
        ... on GraphEntityError {
          statusCode
          message
        }
      }
      teamHealthScoreForTeamErrorable(
        timeZone: $timeZone
        rangeMin: $rangeMin
        rangeMax: $rangeMax
        teamId: $teamId
      ) @include(if: $hasTeams) {
        __typename
        ... on GraphEntityError {
          statusCode
        }
        ... on TeamHealthScore {
          myFocusTimeScore {
            calendarId
            totalMinutes
            ...TeammateAnalyticsCard_calendarFocusTimeScore
          }
          calendarFocusTimeScores {
            calendarId
            totalMinutes
            ...TeammateAnalyticsCard_calendarFocusTimeScore
          }
          profileTimeZones {
            calendarId
            ...TeammateAnalyticsCard_profileTimeZone
            ...TeammateAnalyticsCard_currentUserTimeZone
          }
          persons {
            __typename
            ... on GraphEntityError {
              message
            }
            ... on PersonList {
              list {
                ...TeammateAnalyticsCard_person
                primaryEmail
                emails
                profile {
                  givenName
                  familyName
                  externalImageUrl
                }
                isYou
              }
            }
          }
          orgPersons {
            __typename
            ... on GraphEntityError {
              message
            }
            ... on OrgPersonList {
              list {
                ...TeammateAnalyticsCard_orgPerson
                primaryCalendarId
                calendarAliases
                profile {
                  givenName
                  familyName
                  externalImageUrl
                }
                isYou
              }
            }
          }
        }
      }
      teamHealthScoreJustForUserErrorable(
        timeZone: $timeZone
        rangeMin: $rangeMin
        rangeMax: $rangeMax
      ) {
        __typename
        ... on GraphEntityError {
          statusCode
        }
        ... on TeamHealthScore {
          myFocusTimeScore {
            calendarId
            totalMinutes
            ...TeammateAnalyticsCard_calendarFocusTimeScore
          }
          calendarFocusTimeScores {
            calendarId
            totalMinutes
            ...TeammateAnalyticsCard_calendarFocusTimeScore
          }
          profileTimeZones {
            calendarId
            ...TeammateAnalyticsCard_profileTimeZone
            ...TeammateAnalyticsCard_currentUserTimeZone
          }
          persons {
            __typename
            ... on GraphEntityError {
              message
            }
            ... on PersonList {
              list {
                ...TeammateAnalyticsCard_person
                primaryEmail
                emails
                profile {
                  givenName
                  familyName
                  externalImageUrl
                }
                isYou
              }
            }
          }
        }
      }
      teamCalendarStatusErrorable(timeZone: $timeZone) {
        __typename
        ... on CalendarStatusList {
          list {
            calendarId
            ...TeammateAnalyticsCard_calendarStatus
          }
        }
        ... on GraphEntityError {
          message
          statusCode
        }
      }
    }
  `,
  user: graphql`
    fragment TeamHealthDashboard_user on User {
      id
    }
  `,
};

export const query = graphql`
  query TeamHealthDashboardRendererQuery(
    $timeZone: String!
    $rangeMin: DayTimeSlotInput!
    $rangeMax: DayTimeSlotInput!
    $teamId: String!
    $hasTeams: Boolean!
  ) {
    viewer {
      user {
        ...TeamHealthDashboard_user
        orgs(first: 1000000) {
          edges {
            node {
              ...TeamHealthDashboard_org
                @arguments(
                  timeZone: $timeZone
                  rangeMin: $rangeMin
                  rangeMax: $rangeMax
                  teamId: $teamId
                  hasTeams: $hasTeams
                )
            }
          }
        }
      }
    }
  }
`;
